import Button from './Button'
import Link from './Link'

const LinkButton = Button.withComponent(Link)

export default LinkButton
